/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-09T14:42:50.434
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentHouseSalesPriceEditInit,
	getRentHouseSalesPriceView
} from '@api/rentmanage/RentHouseSalesPrice';

import {
listRentHouseSalesPriceItemInit,
listRentHouseSalesPriceItemByAuthorizations,
deleteRentHouseSalesPriceItem
} from '@api/rentmanage/RentHouseSalesPriceItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getRentHouseSalesPriceEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesPriceEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentHouseSalesPriceView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentHouseSalesPriceView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
